import React, { Component } from 'react';
import '../../css/admin/HeaderAdmin.css';
import logo from "../../assets/logo_espol_blanco_mr.svg";
import { memo } from 'react';

export class HeaderAdmin extends Component {
    render() {
    //console.log("render de headeradmin"); 

    return (
        <div className='adminHeader-header'>
            <div className="row">
                <div className="col-md-9 col-lg-9"> 
                    <img className='logo' src={logo} alt="Logo espol" ></img>
                </div>
                <div className='col-md-3 col-lg-3 adminHeader-container'>
                    <div className='text-right usuarioHeader'>
                        <span>{this.props.nombresCompletos}</span>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default memo(HeaderAdmin);
